module.exports = __webpack_public_path__ + "static/media/clinical-reporting-system-medical-data-infographic.e1fcac12.webp";